<template>
  <div class="sidebar" :class="{ 'sidebar-collapsed': isCollapsed }" data-tour="sidebar">
    <div class="logo-container">
      <div class="logo-wrapper" v-if="!isCollapsed">
        <img src="@/assets/images/trazalogis-logo.svg" alt="Trazalogis" class="logo-image" />
        <h1 class="logo-text">Trazalogis</h1>
      </div>
      <div class="logo-icon-wrapper" v-else>
        <img src="@/assets/images/trazalogis-icon.svg" alt="T" class="logo-icon-image" />
      </div>
    </div>
    
    <!-- Información del usuario -->
    <div class="user-info" v-if="!isCollapsed && currentUser">
      <div class="user-avatar">
        <i class="bi bi-person-circle"></i>
      </div>
      <div class="user-details">
        <div class="user-name">{{ currentUser.username }}</div>
        <div class="user-role">{{ getRoleText(currentUser.role) }}</div>
      </div>
    </div>
    
    <nav>
      <ul>
        <!-- Menú para OPERARIOS -->
        <template v-if="isOperator">
          <li>
            <router-link to="/operator" class="nav-link" :title="isCollapsed ? 'Mi Dashboard' : ''" data-tour="operator-dashboard" @click="handleNavClick">
              <i class="bi bi-speedometer2"></i> <span v-if="!isCollapsed">Mi Dashboard</span>
            </router-link>
          </li>
          <li>
            <router-link to="/inventario" class="nav-link" :title="isCollapsed ? 'Consultar Inventario' : ''" data-tour="inventory-link" @click="handleNavClick">
              <i class="bi bi-list-check"></i> <span v-if="!isCollapsed">Consultar Inventario</span>
            </router-link>
          </li>
        </template>

        <!-- Menú para ADMINISTRADORES/SUPERVISORES -->
        <template v-if="isAdmin">
          <!--
          <li>
            <router-link to="/analytics" class="nav-link" :title="isCollapsed ? 'Análisis' : ''" data-tour="analytics-link" @click="handleNavClick">
              <i class="bi bi-graph-up"></i> <span v-if="!isCollapsed">Análisis</span>
            </router-link>
          </li>
          <li>
            <router-link to="/orders" class="nav-link" :title="isCollapsed ? 'Gestión de Órdenes' : ''" data-tour="orders-link" @click="handleNavClick">
              <i class="bi bi-cart-check"></i> <span v-if="!isCollapsed">Gestión de Órdenes</span>
            </router-link>
          </li>
          
          <li>
            <router-link to="/intelligent-picking" class="nav-link" :title="isCollapsed ? 'Picking Inteligente' : ''" data-tour="intelligent-picking-link" @click="handleNavClick">
              <i class="bi bi-cpu"></i> <span v-if="!isCollapsed">Picking Inteligente</span>
            </router-link>
          </li>
          
          <li>
            <router-link to="/service-assignment" class="nav-link" :title="isCollapsed ? 'Asignación de Servicios' : ''" data-tour="service-assignment-link" @click="handleNavClick">
              <i class="bi bi-clipboard-check"></i> <span v-if="!isCollapsed">Asignación de Servicios</span>
            </router-link>
          </li>
          
          <li>
            <router-link to="/cost-management" class="nav-link" :title="isCollapsed ? 'Gestión de Costos' : ''" data-tour="cost-management-link" @click="handleNavClick">
              <i class="bi bi-currency-dollar"></i> <span v-if="!isCollapsed">Gestión de Costos</span>
            </router-link>
          </li>
          
          <li>
            <router-link to="/instalaciones" class="nav-link" :title="isCollapsed ? 'Instalaciones' : ''" data-tour="installations-link" @click="handleNavClick">
              <i class="bi bi-building"></i> <span v-if="!isCollapsed">Instalaciones</span>
            </router-link>
          </li>
          -->
          <li>
            <router-link to="/ingresos" class="nav-link" :title="isCollapsed ? 'Ingresos' : ''" data-tour="ingresos-link" @click="handleNavClick">
              <i class="bi bi-box-arrow-in-down"></i> <span v-if="!isCollapsed">Ingresos</span>
            </router-link>
          </li>
          <li>
            <router-link to="/egresos" class="nav-link" :title="isCollapsed ? 'Egresos' : ''" data-tour="egresos-link" @click="handleNavClick">
              <i class="bi bi-box-arrow-in-up"></i> <span v-if="!isCollapsed">Egresos</span>
            </router-link>
          </li>
          <li>
            <router-link to="/movimientos-internos" class="nav-link" :title="isCollapsed ? 'Movimientos Internos' : ''" data-tour="movimientos-internos-link" @click="handleNavClick">
              <i class="bi bi-arrow-left-right"></i> <span v-if="!isCollapsed">Movimientos Internos</span>
            </router-link>
          </li>
          <!--
          <li>
            <router-link to="/despachos" class="nav-link" :title="isCollapsed ? 'Despachos' : ''" data-tour="despachos-link" @click="handleNavClick">
              <i class="bi bi-truck"></i> <span v-if="!isCollapsed">Despachos</span>
            </router-link>
          </li>
          
          <li>
            <router-link to="/trazabilidad" class="nav-link" :title="isCollapsed ? 'Gestión de Trazabilidad' : ''" data-tour="trazabilidad-link" @click="handleNavClick">
              <i class="bi bi-geo-alt"></i> <span v-if="!isCollapsed">Gestión de Trazabilidad</span>
            </router-link>
          </li>
          -->
          <li>
            <router-link to="/inventario" class="nav-link" :title="isCollapsed ? 'Gestión de Inventario' : ''" data-tour="inventory-link" @click="handleNavClick">
              <i class="bi bi-list-check"></i> <span v-if="!isCollapsed">Gestión de Inventario</span>
            </router-link>
          </li>
          <li>
            <router-link to="/trazabilidad-dm" class="nav-link" :title="isCollapsed ? 'Trazabilidad DM' : ''" data-tour="trazabilidad-dm-link" @click="handleNavClick">
              <i class="bi bi-heart-pulse"></i> <span v-if="!isCollapsed">Trazabilidad DM</span>
            </router-link>
          </li>
          <li>
            <router-link to="/users" class="nav-link" :title="isCollapsed ? 'Gestión de Usuarios' : ''" data-tour="users-link" @click="handleNavClick">
              <i class="bi bi-people"></i> <span v-if="!isCollapsed">Gestión de Usuarios</span>
            </router-link>
          </li>
        </template>

        <!-- Menú para VISUALIZADORES -->
        <template v-if="isViewer">
          <li>
            <router-link to="/inventario" class="nav-link" :title="isCollapsed ? 'Gestión de Inventario' : ''" data-tour="inventory-link" @click="handleNavClick">
              <i class="bi bi-list-check"></i> <span v-if="!isCollapsed">Gestión de Inventario</span>
            </router-link>
          </li>
        </template>
      </ul>
    </nav>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SideBar',
  props: {
    isCollapsed: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('auth', ['currentUser', 'isAuthenticated']),
    
    isAdmin() {
      return this.currentUser?.role === 'admin'
    },
    
    isOperator() {
      return this.currentUser?.role === 'operator'
    },
    
    isViewer() {
      return this.currentUser?.role === 'viewer'
    },

    isMobile() {
      return window.innerWidth <= 768
    }
  },
  
  methods: {
    getRoleText(role) {
      const roleTexts = {
        admin: 'Administrador',
        operator: 'Operario',
        viewer: 'Visualizador',
        user: 'Usuario'
      }
      return roleTexts[role] || role
    },

    handleNavClick() {
      // Solo cerrar el sidebar en móvil cuando se hace clic en un enlace de navegación
      if (this.isMobile && !this.isCollapsed) {
        this.$emit('close-sidebar')
      }
    }
  }
}
</script>

<style scoped>
.sidebar {
  background-color: #1e2a3a;
  color: white;
  height: 100vh;
  width: 250px;
  position: fixed;
  left: 0;
  top: 0;
  padding-top: 20px;
  z-index: 1000;
  overflow-y: auto;
  transition: width 0.3s ease;
}

.sidebar-collapsed {
  width: 60px;
  overflow-x: hidden;
}

.logo-container {
  text-align: center;
  margin-bottom: 20px;
  padding: 0 10px;
}

.logo-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  gap: 12px;
}

.logo-image {
  width: 50px;
  height: 50px;
  object-fit: contain;
}

.logo-text {
  color: #41B883;
  font-size: 22px;
  font-weight: bold;
  margin: 0;
}

.logo-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo-icon-image {
  width: 40px;
  height: 40px;
  object-fit: contain;
}

/* Información del usuario */
.user-info {
  display: flex;
  align-items: center;
  padding: 15px 20px;
  margin-bottom: 20px;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  margin-left: 10px;
  margin-right: 10px;
}

.user-avatar {
  margin-right: 12px;
}

.user-avatar i {
  font-size: 2rem;
  color: #41B883;
}

.user-details {
  flex: 1;
}

.user-name {
  font-weight: bold;
  font-size: 0.9rem;
  margin-bottom: 2px;
}

.user-role {
  font-size: 0.75rem;
  color: #b0b0b0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

nav ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

nav li {
  margin-bottom: 5px;
}

.nav-link {
  display: flex;
  align-items: center;
  padding: 12px 20px;
  color: #e0e0e0;
  text-decoration: none;
  transition: all 0.3s;
  white-space: nowrap;
  border-radius: 0 25px 25px 0;
  margin-right: 10px;
}

.sidebar-collapsed .nav-link {
  justify-content: center;
  padding: 12px;
  margin-right: 0;
  border-radius: 0;
}

.nav-link:hover {
  background-color: rgba(65, 184, 131, 0.1);
  color: #41B883;
  transform: translateX(5px);
}

.router-link-active {
  background-color: #41B883;
  color: white;
  font-weight: bold;
}

.router-link-active:hover {
  background-color: #369870;
  transform: translateX(0);
}

.nav-link i {
  margin-right: 12px;
  font-size: 1.1rem;
  width: 20px;
  text-align: center;
}

.sidebar-collapsed .nav-link i {
  margin-right: 0;
  font-size: 1.3rem;
}

/* Estilos responsivos para dispositivos móviles */
@media (max-width: 768px) {
  .sidebar {
    transform: translateX(-100%);
    transition: transform 0.3s ease;
    width: 250px;
    z-index: 1001;
  }
  
  .sidebar.sidebar-mobile-open {
    transform: translateX(0);
  }
  
  .sidebar.sidebar-mobile-closed {
    transform: translateX(-100%);
  }
  
  .sidebar-collapsed {
    transform: translateX(-100%);
  }
  
  /* En móvil, no mostrar la información del usuario cuando está colapsado */
  .sidebar-collapsed .user-info {
    display: none;
  }
  
  /* Ajustar navegación en móvil */
  .nav-link {
    padding: 15px 20px;
    font-size: 1rem;
  }
  
  .nav-link i {
    margin-right: 15px;
    font-size: 1.2rem;
  }
}

@media (max-width: 480px) {
  .sidebar {
    width: 280px;
  }
  
  .logo-text {
    font-size: 20px;
  }
  
  .user-name {
    font-size: 0.85rem;
  }
  
  .user-role {
    font-size: 0.7rem;
  }
}
</style>
